import React, { useState, useEffect } from 'react';
import { FaGithub, FaInstagram, FaYoutube } from 'react-icons/fa';
import './Navigation.css';

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll, { passive: true });
  }, []);

  return (
    <nav className={`navbar${scrolled ? ' scrolled' : ''}`} aria-label="Main navigation">
      <a href="#hero" className="nav-logo">r2d2coder</a>
      <div className="nav-links">
        <a href="#sobre-mi"><span className="nav-slash">/</span> sobre mí</a>
        <a href="#cursos"><span className="nav-slash">/</span> cursos</a>
        <a href="#colaboraciones"><span className="nav-slash">/</span> colaboraciones</a>
      </div>
      <div className="nav-social">
        <a href="https://github.com/r2d2-coder-git" target="_blank" rel="noreferrer" aria-label="GitHub">
          <FaGithub />
        </a>
        <a href="https://www.instagram.com/r2d2.coder/" target="_blank" rel="noreferrer" aria-label="Instagram">
          <FaInstagram />
        </a>
        <a href="https://www.youtube.com/channel/UCFu275cNexSxEV09YpnFqrw" target="_blank" rel="noreferrer" aria-label="YouTube">
          <FaYoutube />
        </a>
      </div>
    </nav>
  );
};

export default Navigation;
